const ja = {
  list: {
    pending: "未処理",
    close: "処理済",
    disputeId: "異議申立番号",
    originId: "サイト注文番号",
    omniOriginId: "販売者の注文番号",
    nocases: "データなし",
    disputeId: "異議申立番号",
    originalOrderIDWebsite: "サイト注文番号 / Webサイト",
    websiteOrGroup: "Webサイト / グループ",
    omniWebsiteOrGroup: "店舗/ウェブサイト/グループ",
    creationTime: "異議申立日時",
    time: "期間",
    deadline: "処理期限",
    completeTime: "処理時間",
    amount: "異議申立金額",
    reason: "理由"
  },
  detail: {
    disputeDetail: "紛争の詳細",
    cardAssociation: "カードブランド",
    orderDetail: "元の注文情報",
    websiteURL: "WebサイトURL",
    transactionID: "取引番号",
    itemName: "配送情報",
    amount: "取引金額",
    transactionTime: "元のトランザクション時間",
    shippingName: "荷受人名",
    clientEmail: "ユーザーのメールアドレス",
    shippingPhoneNumber: "荷受人の連絡先番号",
    process: "レコードの処理",
    required: "必須項目です",
    processedOptions: ["消費者に連絡済みだが連絡が取れない", "消費者に連絡を取りましたが、その訴えは不当です。", "消費者に連絡され、解決されました"],
    commentLog: "ノートレコード",
    processed: "処理済",
    pleaseSelect: "選択してください",
    comment: "備考",
    cancel: "キャンセル",
    confirm: "確認",
    successful: "操作は成功しました",
    failure: "操作が失敗しました"
  }
};
export default ja;